import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ActiveSessionsModal = React.lazy(() => import("./active-sessions.modal"));

const ActiveSessions: iModalProps<typeof ActiveSessionsModal, {}> = {
  name: "active-sessions",
  component: GenerateModalWithSuspense(ActiveSessionsModal),
};

export default ActiveSessions;
